<template>
  <div class="modal" v-if="visible" @keydown.esc="closeModal" tabindex="0" @click="check">
    <div class="modal-dialog" :class="widthModal">
      <div class="modal-content">

        <div class="modal-header">
          <div class="modal-title">
            <slot name="header"/>
          </div>
          <span @click="closeModal" class="close-button" data-dismiss="modal"><x-icon size="1x"/></span>
        </div>

        <div class="modal-body default-bg">
          <slot/>
        </div>

        <div class="modal-footer default-bg" v-if="withFooter">
          <slot name="footer"/>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
  import { XIcon } from 'vue-feather-icons';

  export default {
    components: { XIcon },
    computed: {
      visible() {
        return this.value
      },
      widthModal() {
        switch (this.width) {
          case 'sm':
            return 'modal-sm'
          case 'lg':
            return 'modal-lg'
          case 'xl':
            return 'modal-xl'
          default:
            return 'modal-lg'
        }
      }
    },
    methods: {
      check(event) {
        if (event.target === this.$el)
          this.closeModal()
      },
      closeModal() {
        this.$emit('input', false)
      }
    },
    name: 'Modal',
    props: {
      value: { default: false, type: Boolean },
      width: { default: '', type: String},
      withFooter: { default: true, type: Boolean },
    },
  }
</script>

<style scoped lang="scss">

  .modal-title {
    font-size: 18px;
    font-weight: 600;
  }

  .modal-dialog {
    min-width: 450px;
    min-height: 582px;

  }
  .modal {
    display: block;
    background: rgba(0, 0, 0, 0.7);
    overflow-y: scroll;
  }

  .modal-body{
    border-radius: 5px;
  }

  .modal-content{
    border: none;
  }

  .modal-footer{
    border: none;
  }

  .close-button {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    &:hover {
      color: --secondary-text-color;
    }
  }
</style>
